export default {
  methods: {
    formatStepNumber: (n) => {
      if (n < 9) {
        return `0${n + 1}`;
      }
      return n + 1;
    },
  },
};
